export default __webpack_public_path__ + "static/media/SG DE upd2.3a87bb4a.jpg";